

























import { Component, Prop, Vue } from "vue-property-decorator";
import { getZhuanbingContent } from "./zhuanbing-content.service";

@Component
export default class EditZhuanbing extends Vue {
  @Prop({ type: String, default: "艾滋病免疫重建不全" }) readonly diseaseName!: string;
  @Prop({ type: String, default: "aizibing_mianyi_zhongjian_buquan" }) readonly diseaseKey!: string;
  @Prop({ type: String, default: "" }) readonly checkId!: string;
  @Prop({ type: String, default: "" }) readonly checkStartTime!: string;
  @Prop({ type: String, default: "" }) readonly checkEndTime!: string;

  private moduleRouteMap: Record<string, string> = {
    scale: "/main/edit-zhuanbing-scale",
    bianzheng: "/main/edit-zhuanbing-bianzheng",
    zhenghou: "/main/edit-zhuanbing-zhenghou",
  };

  private items: Array<{ label: string; moduleKey: "scale" | "bianzheng" | "zhenghou" }> = [
    { label: "症状体征积分化量表", moduleKey: "scale" },
    { label: "辨证分析判定（轻量演示）", moduleKey: "bianzheng" },
    { label: "中医证候量表", moduleKey: "zhenghou" },
  ];
  private doneMap: Record<string, boolean> = {
    scale: false,
    bianzheng: false,
    zhenghou: false,
  };
  private currentItem: string = "";

  private mounted() {
    this.loadDoneStatus();
  }

  private get patient() {
    return this.$store.state.patient;
  }

  private async loadDoneStatus() {
    try {
      const content = await getZhuanbingContent(this, this.patient.id, this.checkId);
      const modules = content?.report?.zhuanbing?.modules || {};
      this.doneMap = {
        scale: this.hasModuleData(modules.scale),
        bianzheng: this.hasModuleData(modules.bianzheng),
        zhenghou: this.hasModuleData(modules.zhenghou),
      };
    } catch (e) {
      this.doneMap = {
        scale: false,
        bianzheng: false,
        zhenghou: false,
      };
    }
  }

  private hasModuleData(moduleData: any) {
    if (!moduleData) return false;
    if (Array.isArray(moduleData)) return moduleData.length > 0;
    if (typeof moduleData === "object") return Object.keys(moduleData).length > 0;
    return !!moduleData;
  }

  private isDone(moduleKey: string) {
    return !!this.doneMap[moduleKey];
  }

  private handleItemClick(item: { label: string; moduleKey: "scale" | "bianzheng" | "zhenghou" }) {
    if (this.isDone(item.moduleKey)) {
      this.$message.info("当前检查该项已完成");
      return;
    }
    this.currentItem = item.moduleKey;
    this.$emit("open-module", {
      path: this.moduleRouteMap[item.moduleKey],
      query: {
        disease: this.diseaseName,
        diseaseKey: this.diseaseKey,
        checkId: this.checkId,
        checkStartTime: this.checkStartTime,
        checkEndTime: this.checkEndTime,
      },
    });
  }
}
